import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import "./FindUserByCode.html";

import FindUserByCodeComponentController from "./FindUserByCodeComponentController";

export default class FindUserByCodeComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {};
        this.controller = FindUserByCodeComponentController;
        this.templateUrl = "/App/Components/Dashboard/FindUserByCode/FindUserByCode.html";
    }
}

module("mmGui").component("irFindUserByCode", new FindUserByCodeComponent());
